const defaultSportId = 'sr:sport:1';
export default defaultSportId;
